import React, { useState, useEffect, useContext } from "react";
import { LangContext } from "./components/translation/langugeContext";
import { IntlProvider } from "react-intl";
import enMessages from "./components/translation/en";
import arMessages from "./components/translation/ar";

import Footer from "./components/Footer/Footer";
import { Routes, Route, useLocation } from "react-router-dom";

import Blog from "./pages/Blog/Blog";
import axios from "axios";
import { API_BASE_URL } from "././api/config";
import "./App.css";
import ConectionModal from "./components/Modals/ConectionModal";
import SharePopup from "./components/Modals/SharePopup";

import PropertyDetailsPage from "./pages/ProppertyDetailsPage/PropertyDetailsPage";
import HomePage from "./pages/HomePage/HomePage";
import PropertyBrowser from "./pages/FilterPage/PropertyBrowser";
import DevelopersPage from "./pages/DevelopersPage/DevelopersPage";
import BlogDetails from "./pages/Blog/BlogDetails";
import "./App.css";
import { ModalProvider, useModal } from "./components/Modals/ModaleContext";
import { useCurrency } from "./components/Shared/CurrencyContext";
import Header from "./components/Header/Header";

function App() {
  const messages = {
    en: enMessages,
    ar: arMessages,
  };
  const { lang } = useContext(LangContext);
  const location = useLocation();
  const footerData = location.state?.footerData?.paddingLeft || "0px";

  const [loading, setLoading] = useState(true);
  const [activeSlide, setActiveSlide] = useState(0);
  const [pageData, setPageData] = useState({});
  const { currency } = useCurrency();
  // routing flag for pages
  const shouldUseRoutingFlag =
    location.pathname === "/property-browser" ||
    location.pathname === "/blogs" ||
    location.pathname.startsWith("/property-details/") ||
    location.pathname === "/developers" ||
    location.pathname.startsWith("/blog-details/");
  // const [showPopup, setShowPopup] = useState(false);
  // const [isEmail, setIsEmail] = useState(false);
  // const [showSharePopup, setShowSharePopup] = useState(false);

  const slides = [
    { id: 1, src: "/img/1.jpg", alt: "Slide 1" },
    { id: 2, src: "/img/2.webp", alt: "Slide 2" },
    { id: 3, src: "/img/3.png", alt: "Slide 3" },
    { id: 4, src: "/img/4.jpg", alt: "Slide 4" },
    { id: 5, src: "/img/5.jpg", alt: "Slide 5" },
    { id: 6, src: "/img/6.jpg", alt: "Slide 6" },
    { id: 8, src: "/img/8.jpg", alt: "Slide 8" },
    { id: 9, src: "/img/9.jpg", alt: "Slide 9" },
    { id: 10, src: "/img/10.jpg", alt: "Slide 10" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    const slideInterval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearInterval(slideInterval);
    };
  }, []);
  // ${API_BASE_URL}
  useEffect(() => {
    fetch(`${API_BASE_URL}/csrf/`, {
      credentials: "include", // Important to include cookies
    });
    axios
      .get(`${API_BASE_URL}/home/?currency=${currency.code}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        console.log(response.data);

        setPageData(response.data);
      })
      .catch((error) => {
        if (error.response) {
          console.log("Server responded:", error.response);
        } else if (error.request) {
          console.log("Request made but no response:", error.request);
        } else {
          console.log("Error setting up request:", error.message);
        }
      });
  }, [currency]);

  if (loading || !pageData || Object.keys(pageData).length === 0) {
    //page data not null or empty
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#11132F]">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <ModalProvider>
      <IntlProvider key={lang} locale={lang} messages={messages[lang]}>
        <Header
          blur={location.pathname === "/" || location.pathname === ""}
          pageData={pageData}
          routingFlag={shouldUseRoutingFlag}
        />
        <div className="font-[Cairo] overflow-x-hidden bg-[#121525] text-white">
          {/* Background Slider */}
          <div className="bg-slider">
            {slides.map((slide, index) => (
              <img
                key={slide.id}
                src={slide.src}
                alt={slide.alt}
                className={`absolute top-0 left-0 w-full h-full object-cover ${
                  index === activeSlide ? "active" : ""
                }`}
              />
            ))}
          </div>

          <Routes>
            <Route path="" element={<HomePage pageData={pageData} />} />
            <Route
              path="/property-details/:id"
              element={
                <PropertyDetailsPage
                  projects={pageData.projects}
                  amenities={pageData.amenities}
                />
              }
            />
            <Route
              path="/property-browser"
              element={<PropertyBrowser pageData={pageData} />}
            />
            <Route path="/developers" element={<DevelopersPage />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/blog-details/:id" element={<BlogDetails />} />
          </Routes>

          <Footer paddingLeft={footerData} />
          {/* WhatsApp Bubble */}
          <div className="whatsapp-bubble">
            <a
              href="https://wa.me/+201030282513"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </IntlProvider>
      <AllModals />;
    </ModalProvider>
  );
}

const AllModals = () => {
  const { modalType, modalProps, closeModal } = useModal();

  if (!modalType) return null;

  switch (modalType) {
    case "share":
      return (
        <SharePopup
          show={modalProps.show}
          onClose={closeModal}
          propertyId={modalProps.propertyId}
          propertyTitle={modalProps.propertyTitle}
        />
      );
    case "connection":
      return (
        <ConectionModal
          show={modalProps.show}
          onClose={closeModal}
          isEmail={modalProps.isEmail}
        />
      );
    default:
      return null;
  }
};

export default App;
